<template>
	<div class="site-title">
		<div class="gradient gradient-1"></div>
		<div class="gradient gradient-2"></div>
		<div class="gradient gradient-3"></div>
		<div class="title-text">
			<h1 lang="iu" class="h1 h1--iu">ᓱᕈᓯᕐᓄᑦ ᐃᙱᐅᓰᑦ</h1>
			<h1 class="h1 h1--en">Surusirnut Inngiusiit - Songs for Children</h1>
		</div>
	</div>

</template>

<script>
export default {
	name: 'SiteTitle'
}
</script>

<style scoped lang="stylus">

@import "../styles/vars.styl"

.site-title
	position relative
	z-index 0
	left 15%
	.title-text
		position absolute
		left 175px
		top 41px
		.h1
			font-size 36px
			mix-blend-mode: screen;
			opacity: 0.7;
			margin 0
			color $color-light
			white-space nowrap

			body.light &
				color $color-dark

			&--iu

				font-family: Pigiarniq;
				font-style: normal;
				font-weight: 900;
				font-size: 72px;
				line-height: 106px;

				text-align: center;
				letter-spacing: -0.01em;
				text-transform: uppercase;
				z-index 1

			&--en
				font-family: Gilroy
				font-style: italic
				font-weight: 900
				font-size: 28px
				line-height: 35px

				text-align: center
				letter-spacing: 0.03em

	.gradient
		transition all 3000ms ease-in-out

	.gradient-1
		position absolute
		width 528px
		height 528px
		left 85px
		top -237px
		background radial-gradient(96.99% 96.99% at 50% 50%, #38C883 4.8%, #022AFF 36.6%, rgba(2, 42, 255, 0.1) 60.42%)
		mix-blend-mode screen
		opacity 0.4
		border-radius 100%
		transform scale(1)

	.gradient-2
		position absolute
		width 729px
		height 729px
		left 165px
		top -363px
		background radial-gradient(96.99% 96.99% at 50% 50%, #FF522C 4.8%, #083E40 36.6%, rgba(8, 62, 64, 0.1) 60.42%)
		mix-blend-mode screen
		border-radius 100%
		opacity 1
		transform scale(1)

	.gradient-3
		position absolute
		width 789px
		height 789px
		left 125px
		top -363px
		background radial-gradient(50% 50% at 50% 50%, #01C3CB 4.8%, #074523 52.04%, rgba(7, 69, 35, 0) 100%)
		mix-blend-mode screen
		opacity 1
		transform scale(1)
</style>
